<template>
  <TopGradientBlockLayout>
    <template v-slot:top v-if="!currentUserIsWatcher">
      <BaseButton v-if="!openForm" @click="openForm=true"
                  theme="red"
                  class="w-91">
        {{ $t('createTag') }}
      </BaseButton>
      <TagsSettingsForm v-else/>
    </template>
    <TagsList v-if="listLoaded"
              :list="tags_list"
              @edit="void 0;"/>
  </TopGradientBlockLayout>
</template>

<script>
import TopGradientBlockLayout from "@/components/layouts/cabinet/TopGradientBlockLayout";
import BaseButton from "@/components/UI/BaseButton";
import {mapGetters, mapState} from "vuex";
import TagsSettingsForm from "@/components/cabinet/SpaceSettings/TagsSettings/TagsSettingsForm";
import TagsList from "@/components/cabinet/SpaceSettings/TagsSettings/TagsList";

export default {
  name: "TagsSettings",
  components: {TagsList, TagsSettingsForm, BaseButton, TopGradientBlockLayout},
  data() {
    return {
      openForm: false,
      listLoaded: false
    }
  },
  computed: {
    ...mapState('space/tags', ['tags_list']),
    ...mapGetters('space', ['currentUserIsWatcher']),
  },
  async created() {
    await this.$store.dispatch('space/tags/getTags');
    this.listLoaded = true;
  },
  i18n: {
    messages: {
      en: {
        createTag: 'Create tag'
      },
      ru: {
        createTag: 'Добавить тeг'
      }
    }
  }
}
</script>

<style scoped>

</style>